import React from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import useAuthStore from '../../store/useAuthStore'
import { ZoneManagerApartmentListTable } from './ZoneManagerApartmentListTable'

const ZoneManagerApartmentList = () => {
    const { user } = useAuthStore()
    return (
        <NormalContainerWithHeader headerText={"Apartment List"}>
            <ZoneManagerApartmentListTable id={user?.id} />
        </NormalContainerWithHeader>

    )
}

export default ZoneManagerApartmentList